import React, { useState } from 'react';
import { capitalizeFirstLetter, filterObjectValuesNotNull, getFriendlyNameTooltip } from '../../../../../utils';
import Tippy from '@tippyjs/react';
import CIcon from '@coreui/icons-react';
import { debounce } from 'lodash';
import { TagStatus } from '../report-v2/FieldCustom';
import PropTypes from 'prop-types';

const Tag = ({ item, onClick, tagUserSourceDetail }) => {
     return (
          <span
               className={`tag d-flex flex-wrap align-items-center ${typeof onClick !== 'function' && !tagUserSourceDetail ? 'no-click' : ''}`}
               onClick={onClick}
          >
               {item}
          </span>
     );
};

function transformObject(obj) {
     const result = {};

     for (const key in obj) {
          if (key !== 'name' && key !== 'createdAt') {
               const value = obj[key];

               if (Array.isArray(value)) {
                    value.forEach((nestedObj) => {
                         const nestedKey = Object.keys(nestedObj)[0];
                         const nestedValue = nestedObj[nestedKey];
                         result[nestedKey] = nestedValue;
                    });
               } else {
                    result[key] = value;
               }
          }
     }

     return result;
}

const renderTooltipUserSource = (item, key, isCustomTag, originalField) => {
     let nameField = item?.name || item?.companyName || item?.email;
     const handleTrigger = (instance, event) => {
          const listTooltip = document.querySelectorAll('[id^="tippy-"]');
          for (let i = 0; i < listTooltip.length; i++) {
               if (instance.id !== listTooltip[i]._tippy.id) {
                    listTooltip[i].style.display = 'None';
               } else {
                    listTooltip[i].style.display = 'block';
               }
          }
     };

     return (
          <div className="tags-wrapper" key={key}>
               <Tippy
                    content={
                         <div className="tooltip-content">
                              <table>
                                   <tbody>
                                        {
                                        !isCustomTag ?
                                             Object.keys(item).map(
                                                  (key) =>
                                                       key !== 'name' &&
                                                       key !== 'createdAt' &&
                                                       (key !== 'sourceUTMs' && key !== 'clickIds' && item[key] !== '' && key !== 'noted' ? (
                                                            item[key] !== null && item[key] !== undefined ? (
                                                                 <tr key={`${key}`}>
                                                                      <td className="title">
                                                                           {getFriendlyNameTooltip({ field: key }) + ':'}
                                                                           &nbsp;
                                                                      </td>
                                                                      <td className="content">
                                                                           {`${item[key]}`}
                                                                           {key === 'landingPage' || key === 'referrer' ? (
                                                                                <a
                                                                                     href={item[key]}
                                                                                     target="_blank"
                                                                                     rel="noopener noreferrer"
                                                                                     style={{ paddingLeft: '10px' }}
                                                                                >
                                                                                     <CIcon icon="icon-open-website-white" size="sm" />
                                                                                </a>
                                                                           ) : (
                                                                                ''
                                                                           )}
                                                                      </td>
                                                                 </tr>
                                                            ) : null
                                                       ) : key === 'sourceUTMs' || key === 'clickIds' ? (
                                                            item[key] !== null && item[key].length > 0 ? (
                                                                 item[key].map((i, index) => {
                                                                      return (
                                                                           i['value'] !== null && (
                                                                                <tr key={`${key}${index}`}>
                                                                                     {Object.keys(i).map((key, keyIndex) => {
                                                                                          return keyIndex ? (
                                                                                               <td
                                                                                                    key={`${key}${index}`}
                                                                                                    className="content"
                                                                                               >{`${i[key]}`}</td>
                                                                                          ) : (
                                                                                               <td key={`${key}${index}`} className="title">
                                                                                                    {i[key] + ':'}&nbsp;
                                                                                               </td>
                                                                                          );
                                                                                     })}
                                                                                </tr>
                                                                           )
                                                                      );
                                                                 })
                                                            ) : null
                                                       ): key === 'noted' ? (
                                                                 item[key] !== null && item[key] !== undefined ? (
                                                                      <tr key={`${key}`}>
                                                                           <td className="content" colSpan="2">
                                                                                <span dangerouslySetInnerHTML={{ __html: item[key] }} />
                                                                           </td>
                                                                      </tr>
                                                                 ) : null
                                                       ) : item[key] !== null && item[key] !== '' ? (
                                                            <tr key={`${key}`}>
                                                                 {Object.keys(item[key]).map((i, index) => {
                                                                      return index ? (
                                                                           <td key={`${key}${index}`} className="content">{`${item[key][i]}`}</td>
                                                                      ) : (
                                                                           <td key={`${key}${index}`} className="title">
                                                                                {item[key][i] + ':'}&nbsp;
                                                                           </td>
                                                                      );
                                                                 })}
                                                            </tr>
                                                       ) : null)
                                             )
                                        :
                                        <>
                                             {Object.keys(item).filter((i)=> i !== 'name' && i !== 'color').map(
                                                  (key) => {
                                                       return item[key] !== null && item[key] !== undefined && key !== 'name' && key !== 'color' && item[key] !== '' ? (
                                                            <tr key={`${key}`}>
                                                                 <td className="content" style={key === 'value' ? { fontSize: 18 } : {}}>
                                                                      {`${item[key]}`}
                                                                 </td>
                                                            </tr>
                                                       ) : null
                                                  }
                                             )}
                                        </>
                                        }
                                   </tbody>
                              </table>
                         </div>
                    }
                    placement="top"
                    maxWidth="900px"
                    theme="user-source"
                    hideOnClick="false"
                    delay={[200, null]}
                    interactive="true"
                    appendTo={() => document.body}
                    onTrigger={(instance, event) => handleTrigger(instance, event)}
               >
                    <span>
                         { originalField === 'enrichType' ?
                              <TagStatus item={nameField} tagUserSourceDetail={true} color={item.color} />
                              :
                              <Tag item={nameField} tagUserSourceDetail={true} />
                         }
                    </span>
               </Tippy>
          </div>
     );
};

const renderTagEmptyDetail = (label, key) => {
     return (
          <div className="tags-wrapper" key={key}>
               <span>
                    <Tag item={label} />
               </span>
          </div>
     );
};

export const UserSourceDetails = ({ data, isShowTooltipSource = true, isCapitalize, isUpper, isCustomTag, originalField }) => {
     let nameField = data?.name || data?.companyName || data?.email;

     if (data === null || data.length === 0 || typeof data === 'string') {
          return (
               <div className={`view-detail list-tags`} tabIndex={0}>
                    <span>{!data || data.length === 0 ? 'None' : data}</span>
               </div>
          );
     }

     return (
          <div className={`view-detail list-tags`} tabIndex={0}>
               {
                    <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
                         {data?.length
                              ? data.slice(0, 100).map((item, key) => {
                                   const newItem = filterObjectValuesNotNull(item);
                                   let itemName = item?.name || item?.companyName || item?.email;
                                   if (isCapitalize) {
                                        itemName = capitalizeFirstLetter(itemName);
                                   }

                                   if (isUpper) {
                                        itemName = itemName ? itemName.toUpperCase() : '';
                                   }
                                   return Object.keys(newItem).length && isShowTooltipSource ? renderTooltipUserSource(newItem, key, isCustomTag, originalField) : renderTagEmptyDetail(itemName, key);
                              })
                              : !Object.keys(transformObject(filterObjectValuesNotNull(data))).length && !isShowTooltipSource
                                   ? renderTagEmptyDetail(nameField)
                                   : renderTooltipUserSource(data, null ,isCustomTag, originalField)}
                    </div>
               }

          </div>
     );
};

export const UserSourcePathDetails = ({ data }) => {
     const [page, setPage] = useState(1)
     if (data === null || data.length === 0 || typeof data === 'string') {
          return (
               <div className={`view-detail list-tags`} tabIndex={0}>
                    <span>{!data || data.length === 0 ? 'None' : data}</span>
               </div>
          );
     }
     let newData = []
     let limit = 60;
     const pathLoad = [];
     const totalPages = Math.ceil(Math.floor(data.length / limit)) || 0;

     if (data.length > 0) {
          for (let i = 0; i < data.length / limit; i++) {
               const start = i * limit;
               const end = start + limit;
               newData.push({ page: i, data: data.slice(start, end) });
          }
     }

     if (newData.length > 0) {
          for (let i = 0; i <= page; i++) {
               if (newData?.[i]?.data) {
                    pathLoad.push(...newData[i].data);
               }
          }
     }

     const handleScrollTable = (event) => {
          const { scrollTop, scrollHeight, clientHeight } = event;
          if (scrollTop + 20 >= scrollHeight - clientHeight) {
               if (page < totalPages) {
                    setPage((activePageOld) => ++activePageOld);
               }
          }
     };

     const debouncedHandleScrollTable = debounce((event) => {
          handleScrollTable(event);
     }, 100);


     const removeElementTooltipScroll = () => {
          if ('ontouchstart' in window || navigator.maxTouchPoints) {
               const el = document.querySelector('[id^="tippy-"]');
               if (el) {
                    el.remove();
               }
          }
     };

     return (
          <div className="description source-path"
               onScroll={(event) => {
                    removeElementTooltipScroll();
                    const { scrollTop, scrollHeight, clientHeight } = event.target;
                    debouncedHandleScrollTable({ scrollTop, scrollHeight, clientHeight })
               }}
          >
               <div className={`view-detail list-tags`} tabIndex={0}>
                    {
                         <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
                              {pathLoad?.length > 0
                                   ? pathLoad.map((item, key) => {
                                        const newItem = filterObjectValuesNotNull(item);
                                        return Object.keys(newItem).length ? renderTooltipUserSource(newItem, key) : renderTagEmptyDetail(item.name);
                                   })
                                   : renderTagEmptyDetail(data.name)}
                         </div>
                    }
               </div>
          </div>
     );
};

UserSourcePathDetails.propTypes = {
     data: PropTypes.array,
};


UserSourceDetails.propTypes = {
     data: PropTypes.array,
};


Tag.propTypes = {
     tagUserSourceDetail: PropTypes.any,
     onClick: PropTypes.func,
     item: PropTypes.any,
};
